import { X } from "lucide-react";

const DISA_AVATAR =
  "/assets/images/disa-avatar.png";

export default function DisaAboutModal({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      data-testid="disa-about-modal-backdrop"
    >
      <div
        className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
        data-testid="disa-about-modal"
      >
        {/* Teal header — full character image, no circular crop */}
        <div
          className="relative bg-gradient-to-br from-teal-500 to-teal-700 flex justify-center items-end overflow-hidden"
          style={{ minHeight: "180px" }}
        >
          <button
            onClick={onClose}
            className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors z-10"
            data-testid="disa-about-close"
          >
            <X className="w-4 h-4" />
          </button>
          <img
            src={DISA_AVATAR}
            alt="DISA"
            className="h-44 w-auto object-contain object-bottom"
            style={{ filter: "drop-shadow(0 -4px 16px rgba(0,0,0,0.25))" }}
          />
        </div>

        {/* Content */}
        <div className="px-6 pb-6 pt-4 text-center">
          <h2 className="text-xl font-extrabold text-gray-900 dark:text-white mb-1">DISA</h2>
          <p className="text-sm text-teal-600 font-semibold mb-4">Developmental Intelligence &amp; Support Assistant</p>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-3">
            DISA is your dedicated AI therapy companion on Kiddo+. She's designed to support
            parents through every step of their child's developmental journey — from tracking
            milestones to suggesting tailored activities.
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-3">
            Powered by advanced AI and backed by paediatric therapy knowledge, DISA provides warm,
            concise guidance for your child — available
            24/7, just for you and your child.
          </p>
          <p className="text-xs text-gray-400 mt-4 border-t border-gray-100 dark:border-gray-700 pt-3">
            DISA is an AI assistant. Always consult a qualified therapist for clinical decisions.
          </p>
        </div>
      </div>
    </div>
  );
}
